import { Link } from 'react-router-dom';

const chain = ['Общая цель', 'Роли', 'Правила', 'Коммуникация', 'Ответственность', 'Доверие', 'Обратная связь', 'Совместный результат'];

export default function StrongTeamFormation() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          От группы сотрудников к управляемой команде
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Как формируется сильная команда: элементы, которые превращают группу людей в команду, работающую на общий результат
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 mb-12">
          {chain.map((step, i) => (
            <div key={step} className="flex items-center gap-2">
              <span className="bg-white border border-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap">
                {step}
              </span>
              {i < chain.length - 1 && <i className="ri-arrow-right-line text-teal-600"></i>}
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8 max-w-4xl mx-auto mb-8">
          <p className="text-gray-600 text-sm leading-relaxed">
            Командообразование — это не только корпоративное мероприятие или развлекательная активность. Развлекательный формат может поддержать атмосферу, но не создаёт команду. Сильная команда формируется через управленческую работу: постановку общей цели, распределение ролей, выстраивание правил взаимодействия, развитие ответственности и доверия, а также регулярную обратную связь по результату.
          </p>
        </div>

        <div className="text-center">
          <Link
            to="/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie"
            className="inline-flex items-center gap-2 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
          >
            Командообразование
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}